import { render, staticRenderFns } from "./AddNewBudgetModal.vue?vue&type=template&id=58cfed33"
import script from "./AddNewBudgetModal.vue?vue&type=script&lang=js"
export * from "./AddNewBudgetModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports